import { BiHome } from 'react-icons/bi';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  key: string;
  label: string;
  to: string;
  isLast: boolean;
}

interface AppHeaderBreadcrumbTrailProps {
  items: BreadcrumbItem[];
}

export default function AppHeaderBreadcrumbTrail({ items }: AppHeaderBreadcrumbTrailProps) {
  if (items.length === 0) return null;

  return (
    <nav aria-label="breadcrumb" className="app-header__breadcrumb">
      <ol className="app-header__breadcrumb-list">
        <li className="app-header__breadcrumb-item">
          <Link to="/" className="app-header__breadcrumb-link" title="Início">
            <BiHome size={15} aria-hidden />
          </Link>
        </li>
        {items.map((item) => (
          <li
            key={item.key}
            className={`app-header__breadcrumb-item${item.isLast ? ' app-header__breadcrumb-item--active' : ''}`}
            aria-current={item.isLast ? 'page' : undefined}
          >
            <span className="app-header__breadcrumb-sep" aria-hidden>
              /
            </span>
            {item.isLast ? (
              <span className="app-header__breadcrumb-current">{item.label}</span>
            ) : (
              <Link to={item.to} className="app-header__breadcrumb-link">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
